import Icons from './utils/Icons';
import Swiper from 'swiper/bundle';

class Main {
  constructor() {
    this.init();
  }

  init() {
    Icons.load();
    this.initSwiperEvenement();
    this.initSwiperConferencier();
    this.initMenuBurger();
  }

  initSwiperEvenement() {
    const target = document.querySelector('.js-swiper-evenement');

    const swiper = new Swiper(target, {
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }

  initSwiperConferencier() {
    const target = document.querySelector('.js-swiper-conferencier');

    const swiper = new Swiper(target, {
      slidesPerView: 1,
      
      pagination: {
        el: '.swiper-pagination',
      },
      breakpoints: {
        // when window width is >= 320px
        675: {
          slidesPerView: 2,
          spaceBetween: 30,
        }}
    });
  }

  initMenuBurger() {
    const bouton = document.querySelector('.burger');
    const plus = document.querySelector('.plus');
    const conferencier = document.querySelector('.conferencier');

    bouton.addEventListener('click', this.ouvreMenu);
    plus.addEventListener('click', this.ouvreMenu);
    conferencier.addEventListener('click', this.ouvreMenu);
  }

  ouvreMenu() {
    const html = document.documentElement

    html.classList.toggle("openNav")
  }
}
new Main();
